<template>
      <div class="header">Ingezonden formulieren</div>
</template>

<script>
export default {

  data: () => {
    return {

    }
  },
  methods: {

  }
};
</script>

<style scoped>
.header{
  display:flex;
  justify-content: center;
  font-weight:900;
  font-size: 50px;
  margin: 5%;
}
</style>
